import { render, staticRenderFns } from "./ConfiscateEquipment.vue?vue&type=template&id=cc6b2bb0"
import script from "./ConfiscateEquipment.vue?vue&type=script&lang=js"
export * from "./ConfiscateEquipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports